import { Network } from './types';

export function isValidNetworkValue(input: unknown): input is Network {
  return (
    typeof input === 'string' &&
    Object.values(Network).includes(input as Network)
  );
}
